<div class="loader" [class]="class" *ngIf="loading">
  <div>
    <div class="conic-gradient">
      <div class="centerBackground" [style]="'background-color:'+centerBackground"></div>
    </div>
  </div>
</div>
